<!-- <p>edit-dashboard-panel works!</p> -->
<app-dialog-header headerText="Edit Dashboard Panel Component" (onCloseClick)="onCancelClick()"></app-dialog-header>
<div class="main-div">
    <div class="dialog-content">
        <div class="template">
            <div style="width: 100%; height: 100%;" #parentDiv>
                <ng-container [ngTemplateOutlet]="template"
                    [ngTemplateOutletContext]="{data: panelData, testingValue: testingValue}">
                </ng-container>
            </div>
        </div>
        <ng-container *ngIf="showRanges">
            <div class="ranges"
                [ngStyle]="{'grid-template-columns': !panelData.totalise ? '1fr '.repeat(panelData.datapoints.length) : '1fr'}">
                <div class="range-item" *ngFor="let datapoint of panelData.datapoints; let idx = index;">
                    <ng-container *ngFor="let range of panelData.ranges; let rangeIdx = index;">
                        <div class="range-checkbox" *ngIf="range.min[idx] != undefined && range.max[idx] != undefined">
                            <div class="range alignRow">
                                <span>Name:</span>
                                <span><b>{{range.name[idx]}}</b></span>
                                <span>Colour:</span>
                                <div class="alignRow">
                                    <input ejs-colorpicker id='color-picker' type='color'
                                        [value]="range.color[idx] || defaultRangeColours[rangeIdx]"
                                        (change)="colourPickerChange($event, range, idx)" />
                                </div>
                                <span>Start:</span>
                                <ejs-numerictextbox [step]="1" cssClass="e-custom" placeholder="Min"
                                    [(value)]="range.min[idx]">
                                </ejs-numerictextbox>
                                <span>End:</span>
                                <ejs-numerictextbox [step]="1" cssClass="e-custom" placeholder="Max"
                                    [(value)]="range.max[idx]">
                                </ejs-numerictextbox>
                            </div>
                            <div class="border-checkbox alignRow">
                                <span>Creates Tile Border</span>
                                <mat-checkbox color="primary" [checked]="range.createsBorder[idx]"
                                    (change)="checkboxChange($event, range, idx)"></mat-checkbox>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
            <div class="slider alignRow">
                <span>Test Ranges: </span>
                <ejs-slider id="slider" step="1" [(value)]="testingValue" [min]="sliderMin" [max]="sliderMax"
                    orientation="Horizontal"></ejs-slider>
            </div>
        </ng-container>
        <ng-container *ngIf="!showRanges">
            <div class="metric-box">
                <span>Number of Metrics:</span>
                <ejs-numerictextbox [step]="1" cssClass="e-custom" [max]="templateInfo.metrics.length" [min]="1"
                    [(value)]="numberOfMetrics" (change)="numberOfMetricsChange($event)">
                </ejs-numerictextbox>
            </div>
            <div class="metrics" [ngStyle]="{'grid-template-columns': '1fr '.repeat(numberOfMetrics)}">
                <div class="metric-item" *ngFor="let i of [].constructor(numberOfMetrics); let idx=index;">
                    <ejs-dropdownlist id="dropdown" #dropdown [dataSource]='templateInfo.metrics'
                        [fields]="metricFields" placeholder="Select Metric" [value]="
                        templateInfo.metrics[panelData.metricData.metricChoices[idx]] 
                        ? templateInfo.metrics[panelData.metricData.metricChoices[idx]].value 
                        : -1" (change)="metricSelected($event, idx)">
                        <ng-template #itemTemplate let-data>
                            <div>
                                <span>{{ data.text ?? "" }}</span>
                            </div>
                        </ng-template>
                    </ejs-dropdownlist>
                </div>
            </div>
        </ng-container>
        <ejs-multiselect *ngIf="showDatapoints" [mode]="'Box'" [fields]='dpFields'
            placeholder="Choose Datapoints to Include" [showSelectAll]='true' [dataSource]="datapoints"
            [value]="selectedDpIDs" (change)="datapointChoiceChange($event)"></ejs-multiselect>
        <div class="dpError" *ngIf="notValid">Panel can only contain DataPoints with the
            same units.</div>
    </div>
    <div mat-dialog-actions>
        <button mat-button (click)="onDialogClose()" [disabled]="dialogForm.invalid">Ok</button>
        <button mat-button (click)="onCancelClick()" cdkFocusInitial>Cancel</button>
    </div>
</div>